export const OUTLETS_FETCH_REQUEST = "OUTLETS_FETCH_REQUEST";
export const OUTLETS_FETCH_SUCCESS = "OUTLETS_FETCH_SUCCESS";
export const OUTLETS_FETCH_FAILURE = "OUTLETS_FETCH_FAILURE";
